import { render, staticRenderFns } from "./NewForm.vue?vue&type=template&id=42631138&scoped=true"
import script from "./NewForm.vue?vue&type=script&lang=js"
export * from "./NewForm.vue?vue&type=script&lang=js"
import style0 from "./NewForm.vue?vue&type=style&index=0&id=42631138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42631138",
  null
  
)

export default component.exports